// Vite uses import.meta.env instead of process.env
const AppConfig = Object.freeze({
  // Auth0 Configuration
  auth0Domain: import.meta.env.VITE_AUTH0_DOMAIN,
  auth0ClientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  auth0Audience: import.meta.env.VITE_AUTH0_AUDIENCE,
  
  // API Configuration
  cookieDomain: import.meta.env.VITE_COOKIE_DOMAIN,
  graphQlService: import.meta.env.VITE_GRAPHQL_SERVICE,
  wpApiRoot: import.meta.env.VITE_WP_API_ROOT,
  
  // Legacy Okta endpoints (will be removed)
  loginLanding: import.meta.env.VITE_LOGIN_LANDING,
  loginEndpoint: import.meta.env.VITE_LOGIN_ENDPOINT,
  logoutEndpoint: import.meta.env.VITE_LOGOUT_ENDPOINT,
})

export default AppConfig
